/**
 * Verify SMS Actor
 *
 * Verifies OTP code and authenticates user
 * Uses POST /otp/submit-by-userid endpoint via kiosk server action
 */

import { submitOTP } from "@/app/directories/kiosk/server-actions/otp-actions";
import type { OTPData } from "@/lib/interfaces";
import { fromPromise } from "xstate";

export interface VerifySMSInput {
  userId: string;
  otp: string;
  otpTime: string;
}

export interface VerifySMSOutput {
  verified: true;
}

/**
 * Verify SMS Actor Implementation
 */
export const verifySMSActor = fromPromise<VerifySMSOutput, VerifySMSInput>(
  async ({ input }) => {
    const { userId, otp, otpTime } = input;

    console.log("[verifySMSActor] Verifying OTP:", {
      userId,
      otpLength: otp.length,
      hasOtpTime: !!otpTime,
    });

    try {
      // Prepare OTP data for submission
      const otpData: OTPData = {
        userId,
        OTP: otp,
        time: otpTime,
      };

      console.log("[verifySMSActor] Submitting OTP");

      // Verify OTP using kiosk server action
      const result = await submitOTP(otpData);

      console.log("[verifySMSActor] submitOTP result:", {
        success: result.success,
      });

      // Handle ActionResult response structure
      if (!result.success) {
        console.warn(
          "[verifySMSActor] OTP verification failed:",
          result.error.code,
        );
        const error = new Error(result.error.message) as Error & {
          code?: string;
        };
        error.code = result.error.code;
        throw error;
      }

      console.log("[verifySMSActor] OTP verified successfully");

      // Tokens are automatically set as cookies by submitOTP
      return {
        verified: true,
      };
    } catch (error) {
      if (!(error as Error & { code?: string }).code) {
        console.error("[verifySMSActor] Error verifying OTP:", error);
      }
      throw error;
    }
  },
);
